
const digest = '0404dcc37f0411a4195b6bf8b08d0c8caa18ee65009158213b5cf6261193022f';
const classes = {"wrapper":"_wrapper_19gds_1","header":"_header_19gds_7","title":"_title_19gds_16","button":"_button_19gds_22"};
const css = `._wrapper_19gds_1 {
  padding-left: 24px;
  max-height: 400px;
  margin-bottom: 75px;
}

._header_19gds_7 {
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  justify-content: space-between;
  cursor: pointer;
  padding: 24px 24px 24px 0;
}

._title_19gds_16 {
  font-size: 16px;
  font-weight: 500;
  color: #000000;
}

._button_19gds_22 {
  font-size: 14px;
  color: #1665d8;
  text-decoration: underline;
  padding-right: 20px;
  display: flex;
  align-items: center;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  